import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
/* Actions */
import * as summaryTruckActions from '../../actions/summary_truck/index';

/* Function */
import ObjGeneral from '../function/';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Components Used for the summary trucks view */
import TitleMain from '../../components/summary_truck/title';
import Table from '../../components/summary_truck/table';
import Expired from '../expired/index';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Header from '../../components/summary_truck/header';

class SummaryTruck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      select: '',
      sort: {
        averageScore: null,
        evolutionScore: null,
        inspections: null,
        fails: null,
        severityFails: null,
        tagalias: null
      }
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('form');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('form')) {
          let main;
          if (obj.summaryTruck) {
            main = obj.summaryTruck.main ? obj.summaryTruck.main : obj.generalSetting.main;
          } else {
            main = obj.generalSetting.main;
          }

          // we bring the persisted data
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const mainPers = this.props.filters.main || main;
          // eslint-disable-next-line react/no-did-mount-set-state
          this.setState({ select: mainPers });

          // call to Form's fetch api
          await this.props.actions.fetchSummaryTruckApi({
            main: mainPers,
            dateStart,
            dateEnd,
            pag: this.state.pag
          });
          // COUNT fetch api call
          await this.props.actions.fetchSummaryTruckCountApi({
            main: mainPers,
            dateStart,
            dateEnd
          });
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  // we load the reset function, return the states to their initial state
  componentWillUnmount() {
    this.props.actions.resetSummaryTruck();
  }

  // function performed to sort the table
  handleSort = async event => {
    /* Change sort */
    const sort = { ...this.state.sort };

    if (event.currentTarget.dataset.type === 'averageScore') {
      sort.evolutionScore = null;
      sort.inspections = null;
      sort.fails = null;
      sort.severityFails = null;
      sort.tagalias = null;
    } else if (event.currentTarget.dataset.type === 'evolutionScore') {
      sort.averageScore = null;
      sort.inspections = null;
      sort.fails = null;
      sort.severityFails = null;
      sort.tagalias = null;
    } else if (event.currentTarget.dataset.type === 'inspections') {
      sort.averageScore = null;
      sort.evolutionScore = null;
      sort.fails = null;
      sort.severityFails = null;
      sort.tagalias = null;
    } else if (event.currentTarget.dataset.type === 'fails') {
      sort.averageScore = null;
      sort.evolutionScore = null;
      sort.inspections = null;
      sort.severityFails = null;
      sort.tagalias = null;
    } else if (event.currentTarget.dataset.type === 'severityFails') {
      sort.averageScore = null;
      sort.evolutionScore = null;
      sort.inspections = null;
      sort.fails = null;
      sort.tagalias = null;
    } else if (event.currentTarget.dataset.type === 'tagalias') {
      sort.averageScore = null;
      sort.evolutionScore = null;
      sort.inspections = null;
      sort.fails = null;
      sort.severityFails = null;
    }
    const value = this.state.sort[event.currentTarget.dataset.type] == 'DESC' ? 'ASC' : 'DESC';
    sort[event.currentTarget.dataset.type] = value;
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);
    /* Set sort */
    this.setState({
      sort
    });
    /* Set Pag */
    this.setState({ pag: 1 });
    /* Fetch */
    await this.props.actions.fetchSummaryTruckNoLoadingApi({
      sort,
      pag: 1,
      main: this.state.select,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  // function made to filter by main and date
  handleSubmit = async obj => {
    /* Get Select */
    const group = document.getElementById('group').value;
    this.setState({ select: group });
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate(obj, format);
    /* Set Pag */
    this.setState({ pag: 1 });
    // set filter to persist
    this.props.actions.setFilterSummaryTruck({
      date,
      main: group
    });
    /* Fetch */
    await this.props.actions.fetchSummaryTruckApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      pag: 1
    });
    // COUNT fetch api call
    await this.props.actions.fetchSummaryTruckCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group
    });
  };

  // function performed to paginate
  handleScroll = async event => {
    if (this.state.pag < this.props.count.pages) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight;
      if (scroll >= max) {
        /* Change Pag */
        this.setState({ pag: this.state.pag + 1 });
        const pag = this.state.pag + 1;
        /* Get Date */
        const objDate = JSON.parse(this.props.setting.value);
        const format = this.props.language.account.date.format;
        const date = ObjGeneral.getDate({ id: null }, format);
        /* Fetch */
        await this.props.actions.fetchSummaryTruckNoLoadingApi({
          pag,
          concat: true,
          sort: this.state.sort,
          main: this.state.select,
          dateStart: date.fechaStartFinal,
          dateEnd: date.fechaEndFinal
        });
      }
    }
  };

  render() {
    // the setting object is obtained which we use for the configuration
    const lang = localStoreFN().getItem('lang');
    const obj = JSON.parse(this.props.setting.value);

    // function that configures the settings according to those defined in the view
    const setting = ObjGeneral.getSetting({
      setting: obj.summaryTruck,
      filter: this.props.filter,
      general: obj.generalSetting
    });

    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header
          handleSubmit={this.handleSubmit}
          group={setting.group}
          language={this.props.language}
          filters={this.props.filters}
          filter={setting.filter}
          select={this.state.select}
          date={this.props.dateMax[3]}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (this.props.status === 401 || this.props.statusTags === 401) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (this.props.status === 200 && this.props.statusTags === 200) {
        container = (
          <div className="main-container scroll">
            <TitleMain language={this.props.language} />
            <Table
              pag={this.state.pag}
              loadingTable={this.props.loadingTable}
              handleSort={this.handleSort}
              formInspectionsRange={obj.form.inspectionsRange}
              formAvgRange={obj.form.avgRange}
              severityFailsColor={obj.form.severityFailsColor}
              datos={this.props.datos}
              date={this.props.dateMax[3]}
              language={this.props.language}
              languageFormat={lang}
              main={this.state.select}
              count={this.props.count}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
        // the 500 status of the application
      } else if (this.props.status === 500 || this.props.statusTags === 500) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }
    // in case the setting is not loaded
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,

  dateMax: state.reducer.dashboard.dateMax,

  setting: state.reducer.dashboard.setting,
  datos: state.reducer.summaryTruck.datos,
  loading: state.reducer.summaryTruck.loading,
  status: state.reducer.summaryTruck.status,
  loadingTable: state.reducer.summaryTruck.loadingTable,
  filters: state.reducer.summaryTruck.filters,

  count: state.reducer.summaryTruck.count,

  language: state.reducer.dashboard.language
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(summaryTruckActions, dispatch)
});

SummaryTruck.defaultProps = {
  status: null,
  statusTags: null,
  statusCount: null
};

SummaryTruck.propTypes = {
  count: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  loading: PropTypes.bool.isRequired,
  loadingTable: PropTypes.bool.isRequired,
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  setting: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  status: PropTypes.number,
  statusTags: PropTypes.number,
  actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  dateMax: PropTypes.oneOfType([PropTypes.array]).isRequired,
  filters: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryTruck);



// WEBPACK FOOTER //
// ./source/client/containers/summary_truck/index.jsx